import React, { useMemo } from "react";
import classnames from "classnames";
import "./styles.less";

export const Column = (props) => {
  return <span {...props}></span>;
};

export const Table = (props) => {
  const { data, children } = props;

  const columns = useMemo(() => {
    return (children || []).map((child) => {
      // console.log(child.props);
      return child.props;
    });
  }, [children]);

  return (
    <table className="normal-table">
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key || column.dataIndex}>{column.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          const cls = classnames({ even: index % 2 });
          return (
            <tr className={cls}>
              {columns.map((column) => {
                const value = item[column.dataIndex];
                return (
                <td key={column.key || column.dataIndex}>{column.render ? column.render(value, item) : value}</td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
